import React, { useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import './SecretsModal.css';
import { useModalSelectionGuard, preventModalOverlaySelection } from '../hooks/useModalSelectionGuard';

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Подтвердите действие',
  message,
  confirmLabel = 'OK',
  cancelLabel = 'Отмена',
  confirmVariant = 'default'
}) => {
  useModalSelectionGuard(isOpen);

  const handleCancel = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleConfirm = useCallback(() => {
    onConfirm();
    onClose();
  }, [onConfirm, onClose]);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        handleCancel();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, handleCancel]);

  if (!isOpen) return null;

  const confirmButtonClass = confirmVariant === 'danger'
    ? 'secrets-danger-btn'
    : 'secrets-save-btn';

  return createPortal(
    <div className="secrets-modal-overlay" onSelectStart={preventModalOverlaySelection}>
      <div className="secrets-modal" onClick={e => e.stopPropagation()}>
        <div className="secrets-modal-header">
          <h2>{title}</h2>
          <button type="button" className="secrets-close-btn" onClick={handleCancel} aria-label="Закрыть">×</button>
        </div>

        <div className="secrets-form">
          <div className="form-group">
            <div className="secrets-modal-summary">{message}</div>
          </div>

          <div className="secrets-modal-buttons">
            <button type="button" className="secrets-cancel-btn" onClick={handleCancel}>
              {cancelLabel}
            </button>
            <button type="button" className={confirmButtonClass} onClick={handleConfirm}>
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmModal;
